import { render, staticRenderFns } from "./Grilla.vue?vue&type=template&id=2a720e10&scoped=true&"
import script from "./Grilla.vue?vue&type=script&lang=js&"
export * from "./Grilla.vue?vue&type=script&lang=js&"
import style0 from "./Grilla.vue?vue&type=style&index=0&id=2a720e10&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a720e10",
  null
  
)

export default component.exports